import { Injectable, inject } from '@angular/core';
import { appSettings } from '@nha/config';
import { ApmService } from '@elastic/apm-rum-angular';

@Injectable()
export class MonitoringService {
	_service: ApmService;

	constructor() {
		const service = inject(ApmService);

		this._service = service;
	}

	init(moduleName: string): void {
		// API is exposed through this apm instance
		if (appSettings.monitoring && appSettings.monitoring.enabled === true) {
			this._service.init({
				...appSettings.monitoring,
				serviceName: moduleName
			});
		}
	}
}
